import React from 'react';
//
import Card from 'antd/lib/card';

const LoadingBlock = ({ width = '100%' }) => {
  return <div style={{ width, margin: 3 }} className="ant-card-loading-block" />;
};

const RowWrapper = ({ children }) => <div style={{ display: 'flex', margin: 3 }}>{children}</div>;

const LoadingCard = () => (
  <Card loading style={{ minHeight: 500 }} bodyStyle={{ minHeight: 500 }}>
    {/* <RowWrapper>
      <LoadingBlock />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="40%" />
      <LoadingBlock width="60%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock />
      <LoadingBlock />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="30%" />
      <LoadingBlock width="70%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="10%" />
      <LoadingBlock width="90%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="50%" />
      <LoadingBlock width="50%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="40%" />
      <LoadingBlock width="60%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="20%" />
      <LoadingBlock width="80%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="30%" />
      <LoadingBlock width="70%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="10%" />
      <LoadingBlock width="90%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="50%" />
      <LoadingBlock width="50%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="40%" />
      <LoadingBlock width="60%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="20%" />
      <LoadingBlock width="80%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="50%" />
      <LoadingBlock width="50%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="40%" />
      <LoadingBlock width="60%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="20%" />
      <LoadingBlock width="80%" />
    </RowWrapper>
    <RowWrapper>
      <LoadingBlock width="20%" />
      <LoadingBlock width="80%" />
    </RowWrapper> */}
  </Card>
);

export default LoadingCard;



// WEBPACK FOOTER //
// ./src/components/common/NedCalendar/LoadingCard/index.js